import React from "react";
import { Chip } from "@mui/material";

import classes from "./MUIChip.module.css";

export default function MUIChip({
  label,
  color,
  bgColor,
  handleClick = () => {},
  ...props
}) {
  return (
    <Chip
      onClick={() => handleClick(label)}
      label={label}
      size="small"
      className={classes.chip}
      sx={{ backgroundColor: bgColor, color, ...props.styles }}
      {...props}
    />
  );
}
